module.exports = __webpack_public_path__ + "static/media/ruok.8abed949.png";